<template>
  <footer class="mobile-footer">
    <div class="mobile-footer__left">
      <img
        src="/static/vector/footer-logo.svg"
        alt="Zonin" class="mobile-footer__logo"
        v-if="$store.state.color === 'white'"
      />
      <img
        src="/static/vector/footer-logo-white.svg"
        alt="Zonin"
        class="mobile-footer__logo"
        v-if="$store.state.color === 'black'"
      />
    </div>
    <div class="mobile-footer__center">
      <span>Via Borgolecco, 9 - 36053 Gambellara <br> (Vicenza) - PIVA 00152380242 - Tel. </span><a href="tel:0444640111">0444640111 <br> </a><span>Fax </span><a href="tel:0444640204">0444640204</a><span> - </span><a href="mailto:info@zonin.it">info@zonin.it</a>
    </div>
    <div class="mobile-footer__right">
      <a href="/privacy#copy" target="_blank">Copyright</a>
      <span> . </span>
      <a href="/privacy" target="_blank">Privacy</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
.mobile-footer {
  display: none;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: calc((100vh / 18) * 1) 0px;
  padding-left: calc((100vw / 32) * 4);
  padding-right: calc((100vw / 32) * 4);
  font-size: rem(16px);
  font-size: calc(16px * var(--rw));

  @include mq($until: ipadP) {
    display: flex;
  }

  @at-root .page-white & {
    color: $color-dark;
  }

  @at-root .page-black & {
    color: $color-white;

    &__center {
      border-color: $color-white;
    }
  }

  &__left,
  &__right,
  &__center {
    padding: calc((100vh / 18) * 1) 0px;
    position: relative;
  }

  &__center {
    border-top: 1px solid $color-gray;
    border-bottom: 1px solid $color-gray;
    font-family: 'IGT Frankling Gothic';
    font-size: rem(18px);
    font-size: calc(18px * var(--rw));
    line-height: rem(30px);
    line-height: calc(30px * var(--rw));
  }

  &__logo {
    margin-left: 0px;
    max-width: 80px;
    height: auto;
  }

  &__right {
    font-size: rem(26px);
    font-size: calc(26px * var(--rw));
  }

  &__right a,
  &__center a {
    @extend %bottom-line;
  }
}
</style>
